import { api } from "./api";
export class essenceClass {
  constructor(code) {
    this.code = code;
  }
  async getStateList() {
    let result = [];
    if (this.code) {
      let list = await api.qo("/state", { classcode: this.code });
      for (let id in list) {
        let item = list[id];
        if (item.classcode === this.code) {
          result.push(item);
        }
      }
    }
    return result;
  }
  async getTypeList() {
    let result = [];
    if (this.code) {
      let list = await api.qo("/type");
      for (let id in list) {
        let item = list[id];
        if (item.entitycode === this.code) {
          result.push(item);
        }
      }
    }
    return result;
  }

  static async getAccess(code) {
    let access = await api.q("/workflow/class/access/decode", { code });
    return access;
  }
  static async canAccess(code) {
    let access = await essenceClass.getAccess(code);
    return access.a || false;
  }
  static async canCreate(code) {
    let access = await essenceClass.getAccess(code);
    return access.c || false;
  }
  static async canUpdate(code) {
    let access = await essenceClass.getAccess(code);
    return access.u || false;
  }
  static async canSelect(code) {
    let access = await essenceClass.getAccess(code);
    return access.s || false;
  }
  static async canDelete(code) {
    let access = await essenceClass.getAccess(code);
    return access.d || false;
  }
}
